import React, { useEffect } from 'react'
import Register from '@/pages/register/register'

interface Props{}
// 领取额度
const GetQuota:React.FC<Props> = () => {
  // Persist query params from /getQuota so they can be used later during auth
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search || '')
      const map: Record<string, string> = {}
      params.forEach((value, key) => {
        if (value !== undefined && value !== null && value !== '') {
          map[key] = value
        }
      })
      sessionStorage.setItem('H5_EXTRA_PARAMS_FROM_GETQUOTA', JSON.stringify(map))
    } catch (e) {
      // ignore
    }
  }, [])
  return (
    <Register type="getQuota" />
  )
}

export default GetQuota